const Icon = (props: any) => {
    return (
        <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.62 19.887a6.7 6.7 0 004.902-.985 10.43 10.43 0 002.478.298c5.459 0 10-4.235 10-9.6C20 4.235 15.459 0 10 0 4.542 0 0 4.235 0 9.6c0 2.57 1.051 4.893 2.743 6.605.238.24.284.456.26.579a4.047 4.047 0 01-.835 1.798.83.83 0 00-.137.788.8.8 0 00.228.34c.103.091.227.152.36.177zM6.153 8.4c-.306 0-.6.126-.816.351-.216.226-.338.53-.338.849 0 .318.122.623.338.848.216.226.51.352.816.352.306 0 .6-.126.816-.352.216-.225.338-.53.338-.848 0-.318-.122-.623-.338-.849a1.132 1.132 0 00-.816-.351zm2.692 1.2c0-.318.122-.623.338-.849.216-.225.51-.351.816-.351.306 0 .6.126.816.351.216.226.338.53.338.849 0 .318-.122.623-.338.848-.216.226-.51.352-.816.352-.306 0-.6-.126-.816-.352a1.225 1.225 0 01-.338-.848zm5-1.2c-.306 0-.6.126-.816.351-.216.226-.338.53-.338.849 0 .318.122.623.338.848.217.226.51.352.816.352.306 0 .6-.126.816-.352.216-.225.338-.53.338-.848 0-.318-.122-.623-.338-.849a1.131 1.131 0 00-.816-.351z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Icon;
